export const image = {
  about: '../v.png',
  avatar: '../v.png',
  audio: '../images/audio.gif',
  poster: '../images/loader.gif',
  rec: '../images/rec.png',
  recording: '../images/recording.png',
  delete: '../images/delete.png',
  locked: '../images/locked.png',
  mute: '../images/mute.png',
  hide: '../images/hide.png',
  stop: '../images/stop.png',
  unmute: '../images/unmute.png',
  unhide: '../images/unhide.png',
  start: '../images/start.png',
  users: '../images/participants.png',
  user: '../images/participant.png',
  username: '../images/user.png',
  videoShare: '../images/video-share.png',
  message: '../images/message.png',
  share: '../images/share.png',
  exit: '../images/exit.png',
  feedback: '../images/feedback.png',
  lobby: '../images/lobby.png',
  email: '../images/email.png',
  chatgpt: '../images/chatgpt.png',
  all: '../images/all.png',
  forbidden: '../images/forbidden.png',
  geolocation: '../images/geolocation.png',
  network: '../images/network.gif',
  save: '../images/save.png',
};

export const ICONS = {
  room: '<i class="fas fa-home"></i>',
  chat: '<i class="fas fa-comments"></i>',
  user: '<i class="fas fa-user"></i>',
  transcript: '<i class="fas fa-closed-captioning"></i>',
  speech: '<i class="fas fa-volume-high"></i>',
  share: '<i class="fas fa-share-alt"></i>',
  ptt: '<i class="fa-solid fa-hand-pointer"></i>',
  lobby: '<i class="fas fa-shield-halved"></i>',
  lock: '<i class="fa-solid fa-lock"></i>',
  unlock: '<i class="fa-solid fa-lock-open"></i>',
  pitchBar: '<i class="fas fa-microphone-lines"></i>',
  mirror: '<i class="fas fa-arrow-right-arrow-left"></i>',
  sounds: '<i class="fas fa-music"></i>',
  fileSend: '<i class="fa-solid fa-file-export"></i>',
  fileReceive: '<i class="fa-solid fa-file-import"></i>',
  recording: '<i class="fas fa-record-vinyl"></i>',
  broadcaster: '<i class="fa-solid fa-wifi"></i>',
  codecs: '<i class="fa-solid fa-film"></i>',
  theme: '<i class="fas fa-fill-drip"></i>',
  recSync: '<i class="fa-solid fa-cloud-arrow-up"></i>',
  refresh: '<i class="fas fa-rotate"></i>',
  up: '<i class="fas fa-chevron-up"></i>',
  down: '<i class="fas fa-chevron-down"></i>',
};
